exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subcomponent--wrapper.subcomponent--wrapper__image-box-preview[data-v-0023f8b0] {\n    width: 100%;\n}\n.subcomponent--wrapper.subcomponent--wrapper__image-box-preview img[data-v-0023f8b0] {\n    width: inherit;\n}\n.image-preview-wrapper[data-v-0023f8b0] {\n    position: relative;\n}\n.bg-wrapper[data-v-0023f8b0] {\n    overflow: hidden;\n}\n.image-preview-wrapper img[data-v-0023f8b0] {\n    max-width: 600px;\n    max-height: 400px;\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n.image-without-bg[data-v-0023f8b0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n", ""]);

// exports
